import { render, staticRenderFns } from "./BusinessUserInvites.vue?vue&type=template&id=b5beda9a"
import script from "./BusinessUserInvites.vue?vue&type=script&lang=js"
export * from "./BusinessUserInvites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports